import { EntityType } from 'UI/constants/entityTypes';

const getSpecialtyProps = specialtyDetails => ({
  description: specialtyDetails.details,
  detailsLabel: specialtyDetails.detailsLabel
});

const ENTITY_PROPS_FACTORIES = {
  [EntityType.Candidate]: ({ item, specialtyDetails }) => ({
    title: item.full_name,
    subtitle: item.title,
    ...getSpecialtyProps(specialtyDetails),
    type: item.type
  }),
  [EntityType.Joborder]: ({ item, specialtyDetails }) => ({
    title: item.title,
    subtitle: item.company_name,
    ...getSpecialtyProps(specialtyDetails),
    type: item.type
  }),
  [EntityType.Company]: ({ item, specialtyDetails }) => ({
    title: item.name,
    subtitle: specialtyDetails.details,
    description: item.recruiter,
    type: item.type
  })
};

/**
 * Builds the card data for the active inventory entity.
 *
 * @param {Object} params
 * @param {string} params.entity
 * @param {Object} params.item
 * @param {{details: string, detailsLabel: string}} params.specialtyDetails
 * @returns {Object|null}
 */
export const getEntityProps = ({ entity, item, specialtyDetails }) =>
  ENTITY_PROPS_FACTORIES[entity]?.({ item, specialtyDetails }) ?? null;
